import React, { useEffect, useState } from 'react';
import Skeleton from '@mui/material/Skeleton';

let cachedYears = null;
let yearsPromise = null;

const GetYearsOpt = ({ input_id, onLoadingChange, onChange }) => {
  const [options, setOptions] = useState(cachedYears || '');
  const [loading, setLoading] = useState(!cachedYears);

  useEffect(() => {
    if (cachedYears) {
        if (onLoadingChange) onLoadingChange(false);
        return;
    }

    const fetchYears = async () => {
        try {
          if (!yearsPromise) {
              yearsPromise = fetch(`${process.env.REACT_APP_URL_HEADER}/Common/putYears`)
                .then(res => res.text());
          }
          const data = await yearsPromise;
          
          cachedYears = data;
          setOptions(data);
          setLoading(false); 
          if (onLoadingChange) onLoadingChange(false); 

        } catch (error) {
          console.error("Error fetching years:", error);
          yearsPromise = null;
          setLoading(false);
          if (onLoadingChange) onLoadingChange(false); 
        } finally {
          setLoading(false); 
        }
      };
    fetchYears();
  }, [ ]);

  return ( 
    
    <div>
      {loading ? (
        <Skeleton   width={100} height={40} />
      ) : (
    <select name={input_id} id= {input_id} dangerouslySetInnerHTML={{ __html: options }}  onChange={onChange}  />
  )}
    </div>
    );
};

const getSelectYear = ({ input_id,onLoadingChange }) => {
  return (
    <>
      <GetYearsOpt input_id= {input_id} onLoadingChange={onLoadingChange}/>
    </>
  );
}

export default getSelectYear;
